import { useGlobalContext } from "src/context/useGlobalContext";

import bottleSVG from "../../images/bottle.svg";
import LazyLoadComponent from "../lazyLoadComponent/LazyLoadComponent";

const JuiceRaw = () => {

    const { isMobile, navigateTo } = useGlobalContext();

    return (
        <div className="mb-32">
            <div className="no-scrollbar-mobile flex flex-col items-start sm:items-center mt-20 mb-20">
                <div className="text-2xl lg:text-6xl leading-tight text-animate mb-6 ml-4 max-w-[1280px]">
                    BEAUTIFUL AND PROFESSIONAL
                    <br />
                    UI DESIGN <span className="text-sm text-blue-400 cursor-pointer" onClick={() => navigateTo('show-navigate-to-shopify-modal', true)}>(see live the preview here)</span>
                </div>
            </div>

            <LazyLoadComponent spinner={<img src={bottleSVG} alt="" />} componentName='MangoSite' height='310px' />

            <div className="pt-24 pb-16 bg-white flex flex-col items-center">
                <h2 className="text-center mb-6 max-w-[380px] text-2xl lg:text-4xl lg:max-w-max" style={{color: '#e7b900ff'}}>Bringing E-Commerce to Life with 3D Motion and UX</h2>
                <p className="lg:text-center text-black mb-6 text-left px-4">
                    More than eye candy — this hero section blends layered animation, dynamic layout{!isMobile ? <br /> : ''}
                    logic, and e-commerce integration. Paired with a Shopify dev store, it's a fully{!isMobile ? <br /> : ''}
                    functional UI built to attract, engage, and convert.
                </p>
                <button className="rounded-md bg-orange-700 px-4 py-2 hover:bg-orange-600" onClick={() => navigateTo('show-navigate-to-shopify-modal', true)}>View Live store demo</button>
            </div>
        </div>
    );
};

export default JuiceRaw;